import type { ReactNode } from 'react';

type FieldEmphasis = 'lead' | 'quiet' | 'figure';

type DetailFieldProps = {
  name: string;
  emphasis?: FieldEmphasis;
  className?: string;
  children: ReactNode;
};

// Where the group's heading or the value itself already says what the field is, showing the
// name as well only adds noise — but it still has to be there for anything not reading the page.
const NAMES_KEPT_FOR_SCREEN_READERS: readonly FieldEmphasis[] = ['lead', 'quiet'];

const nameClassName = (emphasis?: FieldEmphasis): string =>
  emphasis !== undefined && NAMES_KEPT_FOR_SCREEN_READERS.includes(emphasis)
    ? 'visually-hidden'
    : 'diagnostics-detail-field-name';

function DetailField({ name, emphasis, className, children }: DetailFieldProps) {
  const classNames = [
    'diagnostics-detail-field',
    emphasis && `diagnostics-detail-field-${emphasis}`,
    className,
  ].filter(Boolean);

  return (
    <div className={classNames.join(' ')} role="group" aria-label={name}>
      <dt className={nameClassName(emphasis)}>{name}</dt>
      <dd className="diagnostics-detail-field-value">{children}</dd>
    </div>
  );
}

export default DetailField;
